export default __webpack_public_path__ + "static/media/carrTkn.72f284a1.svg";